<template>
  <div>
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <div class="bid_table">
            <el-table style="width: 100%" :data="bidTable" class="bidtable">
              <el-table-column prop="title" label="项目标题" min-width="230">
                <template slot-scope="scope">
                  <div class="project">
                    <div class="project_head">
                      <p class="gongshi">公示</p>
                      <p class="title show-one-lines">{{ scope.row.title }}</p>
                    </div>
                    <div class="label">
                      标签：<span>{{ scope.row.label }}</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="tender_no"
                label="项目编号"
                width="130" show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="addtime"
                label="发布时间"
                width="150"
              >
              </el-table-column>
              
              <el-table-column
                prop="status"
                label="招标状态"
                width="100"
              >
              <template slot-scope="scope">
                  <div class="cutoff">
                    <span v-if="scope.row.status == 1">进行中</span>
                    <span v-else-if="scope.row.status == 2">已结束</span>
                  </div>
                </template>
            </el-table-column>
              <el-table-column prop="throw_status" label="审核状态">
                <template slot-scope="scope">
                  <div class="cutoff">
                    <span v-if="scope.row.throw_status == 1">已中标</span>
                    <span v-else-if="scope.row.throw_status == 0">审核中</span>
                    <span v-else-if="scope.row.throw_status == 2">未中标</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="end_time"
                label="结束时间"
                width="130"
              ></el-table-column>
              <el-table-column prop="handle" label="操作" width="150">
                <template slot-scope="scope">
                  <div class="d-flex align-items-center">
                    <div
                      class="cutoff handle look"
                      @click.stop="tendetail(scope)"
                    >
                      <span>查看详情</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="bid_foot">
            <div class="all_foot">共{{ row_count }}项数据</div>
            <div class="pagination">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="pages"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="limit"
                layout="sizes, prev, pager, next, jumper"
                :total="row_count"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "../user/components/user_index";
import Usernavleft from "../user/components/user_navleft";
export default {
  data() {
    return {
      bidTable: [],

      pages: 1,
      limit: 10,
      row_count: 10, //总共有多少条数据
    };
  },
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  created() {
    this.getlist();
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.limit = val;
      this.pages = 1;
      this.getlist();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pages = val;
      this.getlist();
    },
    getlist() {
      let that = this;
      let params = {
        page: this.pages,
        limit: this.limit,
      };
      this.$api
        .tenderlist(params)
        .then((res) => {
          console.log(res);
          if (res.code == 0) {
            that.bidTable = res.data.list;
            that.row_count = Number(res.data.row_count);
            let num = Number(res.data.row_count);
            that.pagerCount = Math.ceil(num % that.limit);
          } else {
            that.$message({
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          that.common.message(that, err);
        });
    },
    tendetail(scope){
        let id=scope.row.id;
        this.$router.push({
            path:"/bidparticulars",
            query:{
                id:id
            }
        })
    },
  },
};
</script>
<style lang="scss" scoped>
.ttshop_user {
  width: 100%;

  .ttshop_usercon {
    padding-top: 20px;
    padding-bottom: 60px;
    box-sizing: border-box;
    .ttshop_useright {
      width: 1000px;
      float: right;
      background: #fff;
      .bid_table {
        // background: #fff;
        padding: 0 16px;
        min-height: 450px;
        .bidtable {
          .project {
            .project_head {
              display: flex;
              align-items: center;
              .gongshi {
                padding: 0 6px;
                background: #f0f5ff;
                border-radius: 3px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #4177e3;
                line-height: 20px;
              }
              .title {
                margin-left: 6px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #333333;
                line-height: 20px;
                flex: 1;
              }
            }
            .label {
              margin-top: 8px;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 20px;
              span {
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                &::after {
                  content: "、";
                }
              }
              span:last-child {
                &::after {
                  content: "";
                }
              }
            }
          }

          .cutoff {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 20px;
            span {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #dd2727;
              line-height: 20px;
            }
          }
          .handle {
            cursor: pointer;
          }
          .look {
            margin-left: 10px;
          }
        }
      }
      .bid_foot {
        margin: 0 24px;
        margin-top: 36px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .all_foot {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.6);
          line-height: 22px;
        }
      }
    }
  }
}
</style>